import React from "react";

const SONG_LIST = [
  {
    index: 1,
    title: "나의사랑 kt wiz",
    subTitle: "End of the world",
    singer: "Skeeter Davis",
    madeBy: "후지퍼시픽 100%",
  },
  {
    index: 2,
    title: "지금 이 순간",
    subTitle: "This is the moment",
    singer: "",
    madeBy: "후지퍼시픽 50% / EKKO 50%",
  },
  {
    index: 3,
    title: "마법의 성",
    subTitle: "마법의 성",
    singer: "더클래식",
    madeBy: "작사, 작곡 - 김광진",
  },
  {
    index: 4,
    title: "라인업송",
    subTitle: "숙명",
    singer: "김상민",
    madeBy: "작사 - 홍지유 / 작곡 - 정기석",
  },
  {
    index: 5,
    title: "안타송 2",
    subTitle: "내 사랑을 받아다오 Stargirl",
    singer: "불독맨션",
    madeBy: "작사, 작곡 - 이한철",
  },
  {
    index: 6,
    title: "let's go kt wiz",
    subTitle: "나 사나이다",
    singer: "이혁준",
    madeBy: "작사, 작곡 - 이한철",
  },
  {
    index: 7,
    title: "안타송 2",
    subTitle: "뿌요뿌요",
    singer: "유피",
    madeBy: "작사, 작곡 - 장용진",
  },
  {
    index: 8,
    title: "김민혁 응원가",
    subTitle: "Run",
    singer: "육중완",
    madeBy: "작사, 작곡 - 문성남",
  },
  {
    index: 9,
    title: "박경수 응원가",
    subTitle: "나에게로 떠나는 여행",
    singer: "버즈",
    madeBy: "작사 - 한경혜 / 작곡 - 고석영",
  },
  {
    index: 10,
    title: "권동진 응원가",
    subTitle: "FORREST GUMP",
    singer: "",
    madeBy: "SONY MUSIC PUBLISHING KOREA",
  },
  {
    index: 11,
    title: "박경수 응원가",
    subTitle: "우리동네 HERO",
    singer: "노라조",
    madeBy: "작사 - 김수정, INNOVATOR / 작곡 SLY, 고진영",
  },
  {
    index: 12,
    title: "장성우 응원가",
    subTitle: "STRANGER BY THE DAY",
    singer: "이동호",
    madeBy: "작사 - 이동호 - 작곡 - 이동호",
  },
  {
    index: 13,
    title: "수원 kt 승리를 위해",
    subTitle: "태극기 휘날리며OST",
    singer: "",
    madeBy: "작곡 - 이동준",
  },
  {
    index: 14,
    title: "팀 응원가",
    subTitle: "마법의 기적",
    singer: "",
    madeBy: "김주일",
  },
];

const TableContent = ({ index, title, subTitle, singer, madeBy }) => {
  const tdStyle = {
    verticalAlign: "middle",
    fontSize: "13px",
    height: "30px",
  };
  return (
    <tr style={{ borderTop: "1px solid #bdbdbd" }}>
      <td style={tdStyle}>{index}</td>
      <td style={tdStyle}>{title}</td>
      <td style={tdStyle}>{subTitle}</td>
      <td style={tdStyle}>{singer}</td>
      <td style={tdStyle}>{madeBy}</td>
    </tr>
  );
};

const SongCopyright = ({ setOpenCopyright, isMobile }) => {
  return (
    <div
      style={{
        backgroundColor: "#fff",
        marginTop: "10px",
        padding: "10px",
      }}
    >
      <table style={{ textAlign: "center", width: "100%" }}>
        <thead style={{ height: "30px" }}>
          <tr>
            <th>No</th>
            <th>응원가 곡명</th>
            <th>노래 제목</th>
            <th>가수</th>
            <th>저작자/퍼블리셔</th>
          </tr>
        </thead>
        <tbody>
          {SONG_LIST.map((song, index) => (
            <TableContent {...song} key={index} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SongCopyright;